import {apiSlice} from './apiSlice';

/**
 * Quản trị gói Subscription (admin) — features/Member/PlanManager. CRUD subscription_plans.
 * Tag 'Plan' để tự refetch danh sách sau khi thêm/sửa/xóa.
 */
export const planApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdminPlans: builder.query({
			query: () => ({url: 'admin/plans', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Plan'],
		}),
		createPlan: builder.mutation({
			query: (body) => ({url: 'admin/plans', method: 'post', data: body}),
			invalidatesTags: ['Plan'],
		}),
		updatePlan: builder.mutation({
			query: ({id, ...body}) => ({url: `admin/plans/${id}`, method: 'put', data: body}),
			invalidatesTags: ['Plan'],
		}),
		deletePlan: builder.mutation({
			query: (id) => ({url: `admin/plans/${id}`, method: 'delete'}),
			invalidatesTags: ['Plan'],
		}),
		// Gói Extra (admin) — CRUD extra_packs (sản phẩm mua thêm hạn mức).
		getAdminExtraPacks: builder.query({
			query: () => ({url: 'admin/extra-packs', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['ExtraPack'],
		}),
		createExtraPack: builder.mutation({
			query: (body) => ({url: 'admin/extra-packs', method: 'post', data: body}),
			invalidatesTags: ['ExtraPack'],
		}),
		updateExtraPack: builder.mutation({
			query: ({id, ...body}) => ({url: `admin/extra-packs/${id}`, method: 'put', data: body}),
			invalidatesTags: ['ExtraPack'],
		}),
		deleteExtraPack: builder.mutation({
			query: (id) => ({url: `admin/extra-packs/${id}`, method: 'delete'}),
			invalidatesTags: ['ExtraPack'],
		}),
		// Tham số giá vốn toàn cục (giá token AI USD/1M, tỉ giá, % dự phòng...) — Option BE.
		getCostSettings: builder.query({
			query: () => ({url: 'admin/cost-settings', method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: ['CostSettings'],
		}),
		// Đổi tham số → giá vốn/lãi các gói đổi theo → invalidate cả 'Plan' để tính lại.
		updateCostSettings: builder.mutation({
			query: (body) => ({url: 'admin/cost-settings', method: 'put', data: body}),
			invalidatesTags: ['CostSettings', 'Plan'],
		}),
		// Cấu hình thanh toán VietQR (ngân hàng/số TK/tên chủ TK cho QR đơn hàng gói) — Option BE.
		getPaymentSettings: builder.query({
			query: () => ({url: 'admin/payment-settings', method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: ['PaymentSettings'],
		}),
		updatePaymentSettings: builder.mutation({
			query: (body) => ({url: 'admin/payment-settings', method: 'put', data: body}),
			invalidatesTags: ['PaymentSettings'],
		}),
		// Danh sách ngân hàng VN (BIN/mã/tên — BE proxy service CMS SkillDo, cache 24h)
		// cho Select trong form cấu hình VietQR; rỗng = FE fallback ô nhập tay.
		getBanks: builder.query({
			query: () => ({url: 'admin/payment-settings/banks', method: 'get'}),
			transformResponse: (body) => body?.data || [],
		}),
	}),
});

export const {
	useGetAdminPlansQuery,
	useCreatePlanMutation,
	useUpdatePlanMutation,
	useDeletePlanMutation,
	useGetAdminExtraPacksQuery,
	useCreateExtraPackMutation,
	useUpdateExtraPackMutation,
	useDeleteExtraPackMutation,
	useGetCostSettingsQuery,
	useUpdateCostSettingsMutation,
	useGetPaymentSettingsQuery,
	useUpdatePaymentSettingsMutation,
	useGetBanksQuery,
} = planApiSlice;
